import { render } from "./DocumentListView.vue?vue&type=template&id=28ed0516&scoped=true&ts=true"
import script from "./DocumentListView.vue?vue&type=script&lang=ts"
export * from "./DocumentListView.vue?vue&type=script&lang=ts"

import "./DocumentListView.vue?vue&type=style&index=0&id=28ed0516&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ed0516"]])

export default __exports__